import React from "react";
import {
    TextField,
    Box,
    Paper,
    Typography,
    FormControl,
    FormLabel,
    Button,
    Tooltip,
    IconButton,
    Breadcrumbs,
    MenuItem,
    Alert,
    LinearProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { Formik } from "formik";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useDispatch, useSelector } from "react-redux";
import {
    fetchApidata,
    getFetchData,
    getFetchsalaryData,
    PermissionApprovalVerify,
    postApidata,
    postData,
    requestMail,
} from "../../store/reducers/Formapireducer";
import FileListPopup from "../../ui-components/FIleViewDialog";
import FileUploadIconButton from "../../ui-components/FileUploadButton";
import { attachmentPost } from "../../store/reducers/LoginReducer";
import GradingIcon from '@mui/icons-material/Grading';
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useEffect, useState, useRef } from "react";
import Popup from "../pages/popup";
import Listviewpopup from "../pages/Lookup";
import Swal from "sweetalert2";
import { LoadingButton } from "@mui/lab";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { FinanceSchema } from "../Security/validation";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import axios from "axios";
import store from "../../index";
import {
    fileUpload,
    imageUpload,
} from "../../store/reducers/Imguploadreducer";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { financeentrySchema } from "../Security/validation";
import { fetchExplorelitview } from "../../store/reducers/Explorelitviewapireducer";
import { Productautocomplete } from "../../ui-components/global/Autocomplete";
import { formGap } from "../../ui-components/global/utils";
import { leaveAppoval, mailNotify } from "../../store/reducers/Listviewapireducer";
import * as Yup from "yup";
import CryptoJS from "crypto-js";

const KEY = CryptoJS.enc.Utf8.parse("1234567890123456"); // 16-byte key
const IV = CryptoJS.enc.Utf8.parse("1234567890123456"); // 16-byte IV
function decryptDataUrlSafe(urlSafeBase64) {
    // Convert back to standard base64
    let base64 = urlSafeBase64.replace(/-/g, "+").replace(/_/g, "/");
    // Add padding if needed
    while (base64.length % 4 !== 0) {
        base64 += "=";
    }

    const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: CryptoJS.enc.Base64.parse(base64) },
        KEY,
        {
            iv: IV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
}
const Salaryadvanceapproval = () => {
    const dispatch = useDispatch();
    const params = useParams();
    const accessID = "TR160";
    var recID = decryptDataUrlSafe(params.id);
    const EMPID = sessionStorage.getItem("EmpId");
    const mode = params.Mode;
    const rowSx = { height: 36, '& td, & th': { py: 0.5 } };
    console.log(params, "find Screen Params");
    var parentID = params.parentID;
    console.log(parentID, "--parentID");
    const filtertype = params.filtertype;
    const [open, setOpen] = useState(false);
    const location = useLocation();
    const rowData = location.state || {};
    console.log(rowData, "--find rowData");
    const navigate = useNavigate();
    const data = useSelector((state) => state.formApi.Data);
    const listViewurl = useSelector((state) => state.globalurl.listViewurl);
    const isLoading = useSelector((state) => state.formApi.loading);
    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState([]);
    const [error, setError] = useState('');
    const getLoading = useSelector((state) => state.formApi.getLoading);
    const Finyear = sessionStorage.getItem("YearRecorid");
    const CompanyID = sessionStorage.getItem("companyId");
    const [showImage, setShowImage] = useState(mode == "IM" ? true : false);
    console.log(CompanyID, "--CompanyID");
    // companyId
    // const { toggleSidebar, broken, rtl } = useProSidebar();
    const validationSchema = Yup.object().shape({
        purpose: Yup.object()
            .nullable()
            .required("Purpose is required"),
    });
    useEffect(() => {
        dispatch(getFetchData({ accessID, get: "get", recID })).then((res) => {
            console.log(res, "response");
            var url = store.getState().globalurl.empGetAttachmentUrl;
            axios
                .get(url, {
                    params: {
                        empId: data.EmployeeID,
                        appId: recID
                    }
                })
                .then((response) => {
                    setFiles(response.data);
                })
                .catch((err) => {
                    setError('Failed to fetch attachments.');
                    console.error(err);
                })
                .finally(() => setLoading(false));
        })
    }, []);
    const [ImageName, setImgName] = useState("");

    const isNonMobile = useMediaQuery("(min-width:600px)");

    const currentDate = new Date().toISOString().split("T")[0];
    const initialValue = {
        applieddate: mode == "A" ? currentDate : data.AppliedDate,
        OHRecordID: data.OverHeadsID,
        date: data.SalaryAdvanceDate,
        referenceifany: data.ReferranceIfAny,
        amount: data.Amount,
        comments: data.Comments,
        purpose: data.OverHeadsID
            ? { RecordID: data.OverHeadsID, Name: data.Name }
            : null,
        managerComments: data.ManagerComments,
        Status: data.Status,

    };

    const salAdFNsave = async (values, resetForm, del) => {
        setLoading(true);
        // console.log(funMode, "+  funMode");

        let action =
            mode === "A" && !del
                ? "insert"
                : mode === "E" && del
                    ? "harddelete"
                    : "update";

        const idata = {
            RecordID: recID,
            SalaryAdvanceDate: values.date,
            ReferranceIfAny: values.referenceifany,
            OverHeadsID: values?.purpose?.RecordID || 0,
            Name: values?.purpose?.Name || "",
            Amount: values.amount,
            Comments: values.comments,
            EmployeeID: mode == "M" ? params.parentID : EMPID,
            Status:
                mode == "A"
                    ? "AL"
                    : mode == "E" && values.Status == "QR"
                        ? "AL"
                        : values.Status,
            AppliedDate: values.applieddate,
            Reason: "",
            ManagerComments: values.managerComments,
            Source: "Self",
        };
        const response = await dispatch(
            PermissionApprovalVerify({

                RecordID: recID,
                EmployeeID: data.EmployeeID,
                ManagerID: params.managerID,
                Status: values.Status,
                Type: "SA",
                Password: values.password,
                ManagerComments: values.managerComments ? values.managerComments : ""
            })
        );
        if (response.payload.Status === "Y") {
            dispatch(mailNotify({
                EmployeeID: data.EmployeeID,
                ManagerID: params.managerID,
                Reason: "",
                RecordID: recID,
                Source: "M",
                Status: values.Status == "AP" ? "Y" : values.Status == "RJ" ? "N" : "Q",
                Type: "SA"
            })
            );
            toast.success(response.payload.Msg);
            navigate(`/approval/notification/SA/${values.Status}`);
        } else {
            console.log("🚀 ~ DTSaveFn ~ response.payload.Msg:", response.payload.Msg)
            toast.error(response.payload.Msg);
        }
    };

    const [isPopupData, setisPopupdata] = React.useState(false);
    const [selectOHLookupData, setselectOHLookupData] = React.useState({
        OHlookupRecordid: "",
        OHlookupCode: "",
        OHlookupDesc: "",
    });
    if (isPopupData == false) {
        selectOHLookupData.OHlookupRecordid = data.OverHeadsID;
        selectOHLookupData.OHlookupCode = data.Code;
        selectOHLookupData.OHlookupDesc = data.Name;
    }

    const [openOHPopup, setOpenOHPopup] = useState(false);
    // const [openEMPLOYEEPopup, setOpenEMPLOYEEPopup] = useState(false);
    function handleShow(type) {
        if (type == "OH") {
            setOpenOHPopup(true);
        }

    }

    const childToParent = (childdata, type) => {
        console.log("type---" + type);
        console.log("Data---" + JSON.stringify(childdata));

        if (type == "OverHead") {
            setisPopupdata(true);
            setselectOHLookupData({
                OHlookupRecordid: childdata.RecordID,
                OHlookupCode: childdata.Code,
                OHlookupDesc: childdata.Name,
            });
            setOpenOHPopup(false);
        }

    };
    const ref = useRef(null);
    // *************** GET FILES FROM INPUT *************** //

    const getFileChange = async (event) => {
        setImgName(event.target.files[0]);

        console.log(event.target.files[0]);

        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("type", "attachments");

        const fileData = await dispatch(imageUpload({ formData }));
        setImgName(fileData.payload.name);
        console.log(">>>", fileData.payload);
        console.log(
            "🚀 ~ file: Editdeliverychalan.jsx:1143 ~ getFileChange ~ fileData:",
            fileData
        );
        if (fileData.payload.Status == "Y") {

            toast.success(fileData.payload.Msg);
        }
    };
    const fnLogOut = (props) => {

        Swal.fire({
            title: `Do you want ${props}?`,

            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: props,
        }).then((result) => {
            if (result.isConfirmed) {
                if (props === "Logout") {
                    navigate("/");
                }
                if (props === "Close") {
                    navigate(-1);
                }
            } else {
                return;
            }
        });
    };
    async function fileUpload(file, EMPID, action, id, purpose) {
        console.log("🚀 ~ fileUpload ~ file:", file)
        const formData = new FormData();
        formData.append('file', file);
        formData.append('empId', data.EmployeeID);
        formData.append('appId', data.RecordID);
        formData.append('type', "SA");
        formData.append('source', "Self");
        formData.append('action', action);
        formData.append('id', id);
        formData.append('purpose', purpose);
        console.log("🚀 ~ fileUpload ~ formData:", formData)
        const respose = await dispatch(attachmentPost({ data: formData }))

        if (respose.payload.success) {
            toast.success(respose.payload.message)
            var url = store.getState().globalurl.empGetAttachmentUrl;
            axios
                .get(url, {
                    params: {
                        empId: data.EmployeeID,
                        appId: data.RecordID,

                    }
                })
                .then((response) => {
                    setFiles(response.data);
                })
                .catch((err) => {
                    setError('Failed to fetch attachments.');
                    console.error(err);
                })
                .finally(() => setLoading(false));
        } else {
            toast.success(respose.payload.message)
        }

        console.log("🚀 ~ fileUpload ~ respose:", respose)
    }
    return (
        <React.Fragment>
            {getLoading ? <LinearProgress /> : false}
            <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0" }}>
                <Box display="flex" justifyContent="space-between" p={2}>
                    <Box display="flex" borderRadius="3px" alignItems="center">
                        <Breadcrumbs
                            maxItems={3}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                            <Typography
                                variant="h5"
                                color="#0000D1"
                                sx={{ cursor: "default" }}
                            >
                                Salary Advance
                            </Typography>
                        </Breadcrumbs>
                    </Box>
                    <Box display="flex">
                        <IconButton color="error" onClick={() => fnLogOut("Close")}>
                            <ResetTvIcon />
                        </IconButton>
                        <IconButton>
                            <LogoutOutlinedIcon
                                color="error"
                                onClick={() => fnLogOut("Logout")}
                            />
                        </IconButton>
                    </Box>
                </Box>
            </Paper>
            {!getLoading ? (
                <Paper elevation={3} sx={{ margin: "10px" }}>
                    {/* <Box m="20px"> */}
                    {mode === "IM" && (
                        <Box
                            display="flex"
                            padding={1}
                            justifyContent="flex-end"
                            mt="2px"
                            gridColumn="span 4"
                            gap={2}
                            marginBottom={-5}
                        >
                            <IconButton
                                onClick={() => setShowImage(prev => !prev)}
                            >
                                <ArrowDownwardIcon sx={{ color: "blue" }} />
                            </IconButton>
                        </Box>)}
                    <Formik
                        initialValues={initialValue}
                        onSubmit={(values, { resetForm }) => {
                            setTimeout(() => {
                                salAdFNsave(values);
                            }, 100);
                        }}
                        validationSchema={validationSchema}
                        enableReinitialize={true}
                    >
                        {({
                            errors,
                            touched,
                            handleBlur,
                            handleChange,
                            isSubmitting,
                            values,
                            handleSubmit,
                            setFieldValue,
                            resetForm,
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box
                                    display="grid"
                                    gridTemplateColumns="repeat(4 , minMax(0,1fr))"
                                    // gap="5px"
                                    gap={formGap}
                                    padding={1}
                                    sx={{
                                        "& > div": {
                                            gridColumn: isNonMobile ? undefined : "span 4",
                                        },
                                    }}
                                >
                                    <FormControl
                                        fullWidth
                                        sx={{ gridColumn: "span 2", gap: "15px" }}
                                    >
                                        <TextField
                                            // disabled={
                                            //     mode == "E" &&
                                            //     values.Status != "AL" &&
                                            //     values.Status != "RC"
                                            // }
                                            name="date"
                                            type="date"
                                            id="date"
                                            label="Date"
                                            variant="standard"
                                            focused
                                            value={values.date}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            inputFormat="YYYY-MM-DD"
                                            error={!!touched.date && !!errors.date}
                                            helperText={touched.date && errors.date}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                                readOnly: true,
                                            }}
                                            autoFocus
                                            required
                                        />
                                        <TextField
                                            name="applieddate"
                                            type="date"
                                            id="applieddate"
                                            label="Applied Date"
                                            variant="standard"
                                            focused
                                            inputFormat="YYYY-MM-DD"
                                            value={values.applieddate}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            error={!!touched.applieddate && !!errors.applieddate}
                                            helperText={touched.applieddate && errors.applieddate}
                                            sx={{ gridColumn: "span 2" }}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                                max: new Date().toISOString().split("T")[0],
                                                readOnly: true,
                                            }}

                                        />
                                        <React.Fragment>
                                            <TextField
                                                // disabled={
                                                //   mode == "E" &&
                                                //   values.Status != "AL" &&
                                                //   values.Status != "QR"
                                                // }
                                                name="referenceifany"
                                                type="text"
                                                id="referenceifany"
                                                label="Reference If Any"
                                                variant="standard"
                                                focused
                                                value={values.referenceifany}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                inputProps={{
                                                    readOnly: true,
                                                }}
                                                error={
                                                    !!touched.referenceifany && !!errors.referenceifany
                                                }
                                                helperText={
                                                    touched.referenceifany && errors.referenceifany
                                                }
                                                autoFocus
                                                required
                                            />

                                            <FormControl sx={{ gridColumn: "span 4", display: "flex" }}>
                                                <Productautocomplete
                                                    variant="outlined"
                                                    name="purpose"
                                                    label={
                                                        <>
                                                            Purpose<span style={{ color: "red" }}> * </span>
                                                        </>
                                                    }
                                                    id="purpose"
                                                    value={values.purpose}
                                                    onChange={(newValue) => {
                                                        setFieldValue("purpose", newValue);
                                                    }}
                                                    disabled

                                                    url={`${listViewurl}?data={"Query":{"AccessID":"2032","ScreenName":"Purpose","Filter":"FinanceCategoryType='E' AND companyID='${CompanyID}'","Any":""}}`}
                                                />
                                            </FormControl>
                                            {touched.purpose && errors.purpose && (
                                                <div style={{ color: "red", fontSize: "12px", marginTop: "-8px" }}>
                                                    {errors.purpose}
                                                </div>
                                            )}
                                            {/* </FormControl> */}

                                            <TextField
                                                name="amount"
                                                type="text"
                                                id="amount"
                                                label="Amount"
                                                variant="standard"
                                                focused
                                                value={values.amount}
                                                onBlur={handleBlur}
                                                onChange={handleChange}

                                                error={!!touched.amount && !!errors.amount}
                                                helperText={touched.amount && errors.amount}

                                                autoFocus
                                                InputProps={{
                                                    inputProps: {
                                                        readOnly: true,
                                                        style: { textAlign: "right" },
                                                        min: 0,
                                                        max: 24,
                                                    },
                                                }}
                                                required
                                            />

                                            <TextField

                                                fullWidth
                                                variant="outlined"
                                                type="text"
                                                label="Comments"
                                                required
                                                multiline
                                                rows={6}
                                                value={values.comments}
                                                id="comments"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                name="comments"
                                                error={!!touched.comments && !!errors.comments}
                                                helperText={touched.comments && errors.comments}
                                                sx={{
                                                    gridColumn: "span 2",
                                                    backgroundColor: "",
                                                    "& .MuiFilledInput-root": {
                                                        backgroundColor: "",
                                                    },
                                                }}
                                                inputProps={{
                                                    readOnly: true,
                                                }}
                                                focused
                                            />



                                            <TextField
                                                //   disabled={mode == "E" && values.Status != "AL"}
                                                fullWidth
                                                variant="outlined"
                                                type="text"
                                                label="Manager Comments"
                                                required
                                                multiline
                                                rows={6}
                                                value={values.managerComments}
                                                id="managerComments"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                name="managerComments"
                                                sx={{
                                                    gridColumn: "span 2",
                                                }}
                                                focused
                                            />

                                            <TextField
                                                select
                                                label="Status"
                                                id="Status"
                                                name="Status"
                                                value={values.Status}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                required
                                                focused
                                                variant="standard"
                                            >
                                                {/* {mode != "M" && <MenuItem value="AL">Applied</MenuItem>} */}
                                                <MenuItem value="AP">
                                                    Approved
                                                </MenuItem>
                                                <MenuItem value="RJ">
                                                    Rejected
                                                </MenuItem>
                                                <MenuItem value="QR">Query</MenuItem>
                                            </TextField>

                                        </React.Fragment>
                                    </FormControl>
                                </Box>
                                <Box
                                    display="flex"
                                    justifyContent="end"
                                    mt="20px"
                                    gap="20px"
                                    padding={1}
                                // flexDirection={isNonMobile ? "row" : "column"}
                                >
                                    {data.Status == "AP" && (
                                        <Alert variant="filled" sx={{ mt: 1 }} severity="success">
                                            Your Salary Advance request has been Approved
                                        </Alert>
                                    )}

                                    {data.Status == "RJ" && (
                                        <Alert variant="filled" sx={{ mt: 1 }} severity="error">
                                            Your Salary Advance request has been Rejected.
                                        </Alert>
                                    )}
                                    {data.Status == "QR" && (
                                        <Alert variant="filled" sx={{ mt: 1 }} severity="warning">
                                            Your Salary Advance request has been Queried.
                                        </Alert>
                                    )}
                                    <TextField
                                        required
                                        name="password"
                                        type="password"
                                        id="password"
                                        label="Password"
                                        variant="standard"
                                        focused
                                        value={values.password}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        fullWidth={isNonMobile ? false : true}
                                        // sx={{ gridColumn: "span 2", width: 300 }}
                                        inputProps={{ readOnly: data.Status == "AP" || data.Status == "RJ" ? true : false }}
                                    />
                                    <LoadingButton
                                        disabled={data.Status == "AP" || data.Status == "RJ"}
                                        color="success"
                                        variant="contained"
                                        type="submit"
                                        loading={isLoading}
                                    >
                                        Submit
                                    </LoadingButton>
                                </Box>
                            </form>
                        )}
                    </Formik>
                    <FileListPopup
                        open={open}
                        onClose={() => setOpen(false)}
                        appId={recID}
                        empId={EMPID}
                    />
                    <Popup
                        title="Purpose"
                        openPopup={openOHPopup}
                        setOpenPopup={setOpenOHPopup}
                    >
                        <Listviewpopup
                            accessID="2032"
                            screenName="OverHead"
                            childToParent={childToParent}
                            filterName={"FinanceCategoryType"}
                            filterValue={parentID}
                        />
                    </Popup>
                </Paper>
            ) : (
                false
            )}
            {mode === "IM" && files.length > 0 ? (
                <Box mt={2}
                >
                    <Paper elevation={3} sx={{ padding: 2 }}>
                        {/* <Typography variant="h6" gutterBottom>
              Uploaded Files
            </Typography> */}
                        <TableContainer component={Paper} >
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={rowSx}>
                                        <TableCell width={20}><strong>SL#</strong></TableCell>
                                        <TableCell><strong>Uploaded Date</strong></TableCell>
                                        <TableCell ><strong>Filename</strong></TableCell>
                                        <TableCell ><strong>Purpose</strong></TableCell>
                                        <TableCell ><strong>Source</strong></TableCell>
                                        <TableCell><strong>View</strong></TableCell>


                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {files.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center">
                                                No files uploaded yet.
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        files.map((file, index) => (
                                            <TableRow key={file.id || index} sx={rowSx}>
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell>{file.uploadedDate}</TableCell>
                                                <TableCell>{file.filename}</TableCell>
                                                <TableCell>{file.purpose}</TableCell>
                                                <TableCell>{file.source}</TableCell>
                                                <TableCell>
                                                    <Tooltip title="Open File">
                                                        <IconButton
                                                            color="primary"
                                                            component="a"
                                                            href={file.url}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            size="small"
                                                        >
                                                            <OpenInNewIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="delete">
                                                        <IconButton
                                                            color="error"
                                                            onClick={() => fileUpload(
                                                                "",
                                                                data.EmployeeID,
                                                                "delete",
                                                                file.id,
                                                                file.purpose
                                                            )}
                                                            size="small"
                                                        >
                                                            <DeleteForeverIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>

                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Box>
            ) : null}
        </React.Fragment>
    );
};

export default Salaryadvanceapproval;
